export var DateUtil;
(function (DateUtil) {
    /**
     * シンプルな年月日のテキストを返す
     * 引数例: "2021/04/05 12:21:42", "2021/11/25 09:17:20"
     * 出力例: 2021/04/05, 2021/11/25
     * @param dateText
     * @param separateChar
     */
    function createSimpleDateFormatTextForString(dateText, separateChar = '/') {
        if (dateText == null) {
            return '';
        }
        const date = new Date(dateText);
        return createSimpleDateFormatTextForDate(date, separateChar);
    }
    DateUtil.createSimpleDateFormatTextForString = createSimpleDateFormatTextForString;
    /**
     * シンプルな年月日のテキストを返す
     * 出力例: 2021/04/05, 2021/11/25
     * @param date
     * @param separateChar
     */
    function createSimpleDateFormatTextForDate(date, separateChar = '/') {
        if (date == null) {
            return '';
        }
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const dateFormatText = `${year}${separateChar}${month}${separateChar}${day}`;
        return dateFormatText;
    }
    DateUtil.createSimpleDateFormatTextForDate = createSimpleDateFormatTextForDate;
    function createSimpleTimeFormatTextForString(dateTimeText, useSeconds = false) {
        if (dateTimeText == null) {
            return '';
        }
        const dateTime = new Date(dateTimeText);
        return createSimpleTimeFormatTextForDate(dateTime, useSeconds);
    }
    DateUtil.createSimpleTimeFormatTextForString = createSimpleTimeFormatTextForString;
    function createSimpleTimeFormatTextForDate(date, useSeconds = false, separateChar = ':') {
        if (date == null) {
            return '';
        }
        const hour = ('0' + (date.getHours())).slice(-2);
        const minute = ('0' + (date.getMinutes())).slice(-2);
        let appendText = '';
        if (useSeconds) {
            const second = ('0' + (date.getSeconds())).slice(-2);
            appendText = `${separateChar}${second}`;
        }
        const timeFormatText = `${hour}${separateChar}${minute}${appendText}`;
        return timeFormatText;
    }
    DateUtil.createSimpleTimeFormatTextForDate = createSimpleTimeFormatTextForDate;
    function createSimpleDateTimeFormatTextForString(dateTimeText, useSeconds = false) {
        if (dateTimeText == null) {
            return '';
        }
        const dateTime = new Date(dateTimeText);
        return createSimpleDateTimeFormatTextForDate(dateTime, useSeconds);
    }
    DateUtil.createSimpleDateTimeFormatTextForString = createSimpleDateTimeFormatTextForString;
    function createSimpleDateTimeFormatTextForDate(date, useSeconds = false) {
        const dateFormatText = createSimpleDateFormatTextForDate(date);
        const timeFormatText = createSimpleTimeFormatTextForDate(date, useSeconds);
        const dateTimeFormatText = `${dateFormatText} ${timeFormatText}`;
        return dateTimeFormatText;
    }
    DateUtil.createSimpleDateTimeFormatTextForDate = createSimpleDateTimeFormatTextForDate;
    // ミリ秒
    const OneMinuteMilliSeconds = (1000 * 60); // 分
    const OneHourMilliSeconds = (OneMinuteMilliSeconds * 60); // 時間
    const OneDayMilliSeconds = (OneHourMilliSeconds * 24); // 日
    const OneWeekMilliSeconds = (OneDayMilliSeconds * 7); // 週
    const OneMonthMilliSeconds = (OneDayMilliSeconds * 30); // 月
    const OneYearMilliSeconds = (OneDayMilliSeconds * 365); // 年
    function calculateYearCount(fromDate, targetDate = new Date()) {
        let age = targetDate.getFullYear() - fromDate.getFullYear();
        const thisYearBirthDay = new Date(targetDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        if (targetDate < thisYearBirthDay) {
            age--;
        }
        return age;
    }
    DateUtil.calculateYearCount = calculateYearCount;
    /**
     * 2つの日付の差を表す文字列を返す
     * 出力例: 数秒前, 1分後, 3日前, 1週間後 など
     * @param toDate
     * @param fromDate
     */
    function createDateProgressText(toDate, fromDate = new Date()) {
        const toDateTimeMilliSeconds = toDate.getTime();
        const fromDateTimeMilliSeconds = fromDate.getTime();
        const timeDifferenceMilliSeconds = fromDateTimeMilliSeconds - toDateTimeMilliSeconds;
        let timeDirectionText = '前';
        if (timeDifferenceMilliSeconds < 0) {
            timeDirectionText = '後';
        }
        const timeDifferenceAbsolute = Math.abs(timeDifferenceMilliSeconds);
        // 年
        const yearDifference = timeDifferenceAbsolute / OneYearMilliSeconds;
        if (yearDifference >= 1) {
            return `${Math.floor(yearDifference)}年${timeDirectionText}`;
        }
        // 月
        const monthDifference = timeDifferenceAbsolute / OneMonthMilliSeconds;
        if (monthDifference >= 1) {
            return `${Math.floor(monthDifference)}ヶ月${timeDirectionText}`;
        }
        // 週
        const weekDifference = timeDifferenceAbsolute / OneWeekMilliSeconds;
        if (weekDifference >= 1) {
            return `${Math.floor(weekDifference)}週間${timeDirectionText}`;
        }
        // 日
        const dayDifference = timeDifferenceAbsolute / OneDayMilliSeconds;
        if (dayDifference >= 1) {
            return `${Math.floor(dayDifference)}日${timeDirectionText}`;
        }
        // 時間
        const hourDifference = timeDifferenceAbsolute / OneHourMilliSeconds;
        if (hourDifference >= 1) {
            return `${Math.floor(hourDifference)}時間${timeDirectionText}`;
        }
        // 分
        const minuteDifference = timeDifferenceAbsolute / OneMinuteMilliSeconds;
        if (minuteDifference >= 1) {
            return `${Math.floor(minuteDifference)}分${timeDirectionText}`;
        }
        return `数秒${timeDirectionText}`;
    }
    DateUtil.createDateProgressText = createDateProgressText;
})(DateUtil || (DateUtil = {}));
